<div class="wrapper">
    <div class="page-header" style="background-image: url('./assets/img/sections/bruno-abatti.jpg');">
        <div class="filter"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-6 ml-auto mr-auto">
                    <div class="card card-register">
                        <h3 class="card-title">Welcome</h3>
                        <form class="register-form">
                            <label>Email</label>
                            <input type="email" class="form-control no-border" placeholder="Email">

                            <label>Password</label>
                            <input type="password" class="form-control no-border" placeholder="Password">
                            <button class="btn btn-danger btn-block btn-round">Login</button>
                        </form>
                        <div class="forgot">
                            <a href="javascript:void(0)" class="btn btn-link btn-danger">Forgot password?</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="demo-footer text-center">
                <h6>&copy; {{data | date: 'yyyy'}}, made with <i class="fa fa-heart heart"></i> by Creative Tim</h6>
            </div>
        </div>
    </div>
</div>
